import { useState } from "react";
import { Link } from "react-router-dom";
import PartnerGroupedListingCard from "./PartnerGroupedListingCard";
import { formatAggregateSummary } from "../../../utils/partnerInventoryFormatters";

const UNCLASSIFIED_TRIM_LABEL = "Unclassified trim";

function NeedsReviewBadge({ count, reviewPath }) {
  if (!count) return null;
  return (
    <Link className="partner-grouped-review-badge" to={reviewPath} aria-label={`${count} listings need review`}>
      {count} need review
    </Link>
  );
}

export default function PartnerInventoryTrimGroup({
  trimGroup,
  dealerId,
  path,
  reviewPath,
}) {
  const [expanded, setExpanded] = useState(false);
  const isUnclassified = trimGroup.trim?.label === UNCLASSIFIED_TRIM_LABEL;
  const listings = trimGroup.listings || [];
  const summary = formatAggregateSummary(trimGroup.aggregates);

  return (
    <div className={`partner-grouped-trim${isUnclassified ? " partner-grouped-trim--unclassified" : ""}`}>
      <button
        type="button"
        className="partner-grouped-trim__toggle"
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
      >
        <span className="partner-grouped-trim__label">
          {trimGroup.trim?.label || UNCLASSIFIED_TRIM_LABEL}
          {isUnclassified ? (
            <span className="partner-grouped-review-badge partner-grouped-review-badge--inline" aria-label="Trim missing">
              Trim missing
            </span>
          ) : null}
        </span>
        <span className="muted partner-grouped-trim__meta">
          {trimGroup.count} listing{trimGroup.count === 1 ? "" : "s"}
          {summary ? ` · ${summary}` : ""}
        </span>
      </button>
      <NeedsReviewBadge count={trimGroup.aggregates?.needsReviewCount} reviewPath={reviewPath} />

      {expanded && listings.length ? (
        <div className="partner-grouped-listings partner-grouped-listings--nested">
          {listings.map((listing) => (
            <PartnerGroupedListingCard
              key={listing.id}
              listing={listing}
              dealerId={dealerId}
              path={path}
              reviewPath={reviewPath}
            />
          ))}
          {trimGroup.hasMoreListings ? (
            <p className="muted partner-grouped-more">
              Showing {trimGroup.listingsReturned ?? listings.length} of {trimGroup.count} listings.
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
